<template>
  <div class="login-page">
    <main class="login-page__content">
      <section class="login-page__content--inner">
        <div></div>

        <login-deck class="login-page__login-deck" />
      </section>

      <!-- Show document links inside a dialog -->
      <v-dialog v-model="documentDialogOpen" persistent max-width="390px">
        <v-card flat>
          <button @click="documentDialogOpen = false">
          <v-icon class="close mt-1 mr-1">$sl-close</v-icon>
        </button>

        <DocumentLinksDialog />
        </v-card>
      </v-dialog>
    </main>

    <LoggedOutFooter class="login-page__footer" @show-links="documentDialogOpen = true" />
  </div>
</template>

<script>
import LoginDeck from '@/components/Start/LoginDeck/LoginDeck.vue';
import LoggedOutFooter from '@/components/Start/LoggedOutFooter.vue';
import DocumentLinksDialog from '@/components/Start/dialog/DocumentLinksDialog.vue';

export default {
  name: 'LoginPage',

  components: {
    LoginDeck,
    LoggedOutFooter,
    DocumentLinksDialog
  },

  data: () => ({
    documentDialogOpen: false
  }),
}
</script>

<style lang="scss" scoped>
.login-page {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 64px);
}

.login-page__content {
  width: 100%;
  background: url('@/assets/images/byn-startsida.png')
    no-repeat center / cover !important;
}

.login-page__content--inner {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.login-page__footer {
  flex: 0 0 auto;
}

/* ==========================================
   Larger devices
   ========================================== */

@media (min-width: 769px) {
  .login-page {
    height: calc(100vh - 64px);
    overflow: hidden;
  }

  .login-page__content {
    flex: 1 1 auto;
    min-height: 0;
    padding: 0 1rem;
  }

  .login-page__content--inner {
    height: 100%;
  }
}

/* ==========================================
   Smaller devices
   ========================================== */

@media (max-width: 768px) {
  .login-page {
    min-height: calc(100vh - 64px);
  }

  .login-page__content {
    flex: 0 0 auto;
    padding: 24px 1rem;
  }

  .login-page__content--inner {
    align-items: flex-start;
  }
}
</style>